
angular.module('bmsApp.trugreen.job').controller('TreatmentPlanEmailFormModalCtrl', [
	'$scope',
	'$q',
	'$timeout',
	'$modalInstance',
	'$ngBootbox',
	'EmailAccountsDataSvc',
	'job',
	'customer',
	'email',
	'$log',
	'TGJobSvc',
	'EmailSvc',
	'DocumentSvc',
	'CustomerReminderTemplateSvc',
	function (
		$scope,
		$q,
		$timeout,
		$modalInstance,
		$ngBootbox,
		EmailAccountsDataSvc,
		job,
		customer,
		email,
		$log,
		TGJobSvc,
		EmailSvc,
		DocumentSvc,
		CustomerReminderTemplateSvc) {

		$scope.email = {
			attachments: [],
			adhocAttachments:[], // those uploaded on the fly
			use_template: 1
		};
		angular.extend($scope.email, email);

		// Outgoing email account
		$scope.outgoingEmailAccountsOptions = [];
		EmailAccountsDataSvc.outgoingOptions().then((response) => {
			$scope.outgoingEmailAccountsOptions = response.data.outgoingEmailAccountsOptions;
			$scope.defaultOutgoingEmailAccount = response.data.defaultOutgoingEmailAccount;
			if (!!customer && !!customer.license && customer.license.default_email_account) {
				$scope.email.outgoing_email_account = customer.license.default_email_account.id;
			} else {
				$scope.email.outgoing_email_account = response.data.defaultOutgoingEmailAccount.id;
			}
		});

		$scope.dropzoneErrors = [];
		$scope.dropzone = {
			config: {
				url: 'api/email/upload',
				parallelUploads: 3,
				maxFileSize: 5,
				acceptedFiles: '.csv, .xls, .xlsx, .jpg, .jpeg, .png, .doc, .docx, .pdf',
				eventHandlers: {
					drop: function (event) {
						$scope.dropzoneErrors = [];
					},
					success: function (file, response) {
						$scope.email.adhocAttachments.push({type: 'email', filename: response.filename});
					},
					removedfile: function (file) {
						FileSvc.delete(file.serverFilepath)
							.then(function (response) {
								$log.log('Dropzone file removed');
							}, function (error) {
								$log.error('Failed to remove dropzone file: ' + error);
							});
					},
					error: function (file, errorMessage) {
						$scope.dropzoneErrors.push(errorMessage);
					}
				}
			}
		};
		
		var documentOptionPromise;
		$scope.documentOptions = [];
		documentOptionPromise = DocumentSvc.optionsByTgJob($scope.email.object_id, {});
		documentOptionPromise.then(function (response) {
			$timeout(function () {
				$scope.$apply(function () {
					$scope.documentOptions = response.data.options;
					$scope.loading = false;
				});
			}, 0);
		});

		$scope.addAttachment = function () {
			$scope.email.attachments.push({});
		};

		$scope.removeAttachment = function (attachment) {
			var index = $scope.email.attachments.indexOf(attachment);
			$scope.email.attachments.splice(index, 1);
		};

		$scope.loading = true;
		$scope.processing = false;
		TGJobSvc.getTreatmentPlanEmailTemplate(job.id)
			.then((response) => {
				$scope.email.body = response.data.email_template;
				$scope.email.use_template = response.data.email_signature_enabled;
				$scope.loading = false;
			});


		$scope.formvalidatorconfig = {
			submitHandler: function () {
				$scope.submit($scope.email);
			},
			errorPlacement: function (error) {
				error.appendTo('#email-errors');
			},
			errorContainer: '#email-errors'
		};

		$scope.submit = function (email) {
			$scope.processing = true;
			var modalResult = {};
			EmailSvc.send(email)
				.then(function (response) {
					modalResult.success = response.data.success;
					modalResult.email = email;
					$modalInstance.close(modalResult);
				}, function (error) {
					modalResult.error = error[0];
					$modalInstance.close(modalResult);
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.cancel = function () {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		};

	}]);
